import { useState, useEffect } from 'react';
import {

  Box,
  Snackbar,
  Alert,
} from '@mui/material';

import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSyncContext } from '../contexts/SyncContext';
import { customerBalanceAPI } from '../services/api';

const Layout = () => {
  const { user, } = useAuth();
  const { markInitialSyncComplete, syncStatus } = useSyncContext();

  const [syncNotification, setSyncNotification] = useState({
    open: false,
    message: '',
    severity: 'info'
  });




  // Initial balance sync when the layout loads
  useEffect(() => {
    const performInitialSync = async () => {
      // Check if sync has already been performed in this session
      const syncPerformed = sessionStorage.getItem('initialSyncPerformed');

      if (!syncPerformed && user && !syncStatus.isInitialSyncComplete) {
        try {
          setSyncNotification({
            open: true,
            message: 'Synchronizing customer balances...',
            severity: 'info'
          });

          const response = await customerBalanceAPI.syncAll();

          // Mark sync as performed for this session
          sessionStorage.setItem('initialSyncPerformed', 'true');

          const syncResult = {
            successCount: response.data.successCount,
            errorCount: response.data.errorCount,
            timestamp: new Date()
          };

          // Notify SyncContext that initial sync is complete
          markInitialSyncComplete(syncResult);

          setSyncNotification({
            open: true,
            message: `Balance sync completed: ${response.data.successCount} successful, ${response.data.errorCount} errors`,
            severity: response.data.errorCount > 0 ? 'warning' : 'success'
          });
        } catch (error) {
          console.error('Initial balance sync failed:', error);
          setSyncNotification({
            open: true,
            message: 'Failed to sync customer balances',
            severity: 'error'
          });
          
          // Still mark as complete to prevent retries, but with error
          markInitialSyncComplete({ error: error.message, timestamp: new Date() });
        }
      }
    };

    performInitialSync();
  }, [user, markInitialSyncComplete, syncStatus.isInitialSyncComplete]);

  const handleCloseNotification = () => {
    setSyncNotification(prev => ({ ...prev, open: false }));
  };



  return (
    <Box 
      component="main" 
      sx={{ 
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      <Outlet />


      {/* Sync notification */}
      <Snackbar
        open={syncNotification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={syncNotification.severity}
          sx={{ width: '100%' }}
        >
          {syncNotification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Layout;